var map = {
	"./08-feb-17-events.jpg": 99849,
	"./1.jpg": 1910,
	"./10.jpg": 87822,
	"./11.jpg": 3342,
	"./11_events.jpg": 86098,
	"./12.jpg": 34119,
	"./13.jpg": 34186,
	"./14.jpeg": 56966,
	"./15.jpg": 14378,
	"./16.jpg": 89629,
	"./17-dec-17-events.jpg": 62403,
	"./17.jpg": 37526,
	"./18.jpg": 5216,
	"./19.jpg": 91619,
	"./2.jpg": 91301,
	"./20.jpg": 72541,
	"./21.jpg": 80669,
	"./22-dec-17-events.jpg": 21557,
	"./22.jpg": 8459,
	"./23.jpg": 72957,
	"./24.jpg": 48634,
	"./25.jpg": 7878,
	"./26.jpg": 97560,
	"./29-dec-17-events.jpg": 53235,
	"./3.jpg": 82058,
	"./370_240_events.jpg": 73497,
	"./39.jpg": 51681,
	"./3_3_events.jpg": 32260,
	"./4.jpg": 58613,
	"./41.jpg": 30483,
	"./44.jpg": 42870,
	"./47.jpg": 62792,
	"./5.jpg": 20752,
	"./6.jpg": 30272,
	"./6_events.jpg": 4806,
	"./7.jpg": 45694,
	"./70-independence-day.jpg": 69403,
	"./70-independence-day1.jpg": 12010,
	"./7_events.jpg": 9129,
	"./8.jpg": 60460,
	"./8_events.jpg": 90771,
	"./9-may-17-events.jpg": 83082,
	"./9.jpg": 7174,
	"./BLS-Mock-Drill.jpg": 21245,
	"./Basic-life-support-training.jpg": 63356,
	"./Breast feeding week.jpg": 43759,
	"./CME-Dharawad.jpg": 26950,
	"./Community-Service.jpg": 59759,
	"./Employees-Induction-Program.jpg": 94242,
	"./Ganesh-Chaturthi-Celebration.jpg": 44635,
	"./NABH-Infection-control-training.jpg": 49914,
	"./NABH-training.jpg": 84633,
	"./Participated-in-Neonatology-and-Perinataolgy-panel-discussion.jpg": 1321,
	"./Planet-kids-campaign.jpg": 33925,
	"./VCN-doctors-meeting.jpg": 94679,
	"./antinatal-workshops.jpg": 89659,
	"./baby-94.jpeg": 14512,
	"./baby-shower-1.jpg": 5289,
	"./baby-shower-bangalore.jpg": 50985,
	"./baby-shower-ram-june28.jpg": 98789,
	"./baby-shower.jpg": 60783,
	"./babyshowerevent-1.jpg": 71270,
	"./babyshowerevent-2.jpg": 75175,
	"./bng.jpg": 95434,
	"./celebration-cd.jpg": 78051,
	"./celebration-cd.png": 59433,
	"./childvaccination-01.jpg": 58273,
	"./clinic-nagara-2.jpg": 80968,
	"./clinic-nagara-3.jpg": 28667,
	"./clinic-nagara-4.jpg": 68483,
	"./dentistry.jpg": 40723,
	"./doc-day.jpeg": 78015,
	"./doctors-july1st.jpg": 82221,
	"./event-1.jpg": 26588,
	"./event-3.jpg": 90073,
	"./event-A-30-1ug-2019.png": 20281,
	"./event-B-30-1ug-2019.png": 19749,
	"./event-banner.jpg": 89664,
	"./event-new-1.png": 83355,
	"./event-new-2.png": 44816,
	"./event-new-3.png": 41597,
	"./event-new-5.png": 76611,
	"./event-new-6.png": 86854,
	"./event-new-7.png": 33971,
	"./event-new-8.png": 7001,
	"./event-yoga-day.jpg": 97270,
	"./female-bikers-in-town.jpg": 20921,
	"./grand-inauguration-ceremony.jpg": 82979,
	"./health-checkup-ramanagara.jpg": 65145,
	"./kc-95.jpeg": 41976,
	"./mys.jpg": 73089,
	"./nagarabhavi-clinic.jpg": 36715,
	"./national-gastroneocon.jpg": 81574,
	"./news-letter-launch-1.png": 56626,
	"./news-letter-launch-2.png": 22507,
	"./nurse-day.jpg": 92619,
	"./nurses-quiz-competition.jpg": 59858,
	"./onam-celebration.jpg": 25421,
	"./oneyr-complete.jpg": 41153,
	"./organized-children's-day.jpg": 45107,
	"./orientation.png": 25505,
	"./prematurity-collage.jpg": 12851,
	"./prematurity-collage.png": 19031,
	"./ram.jpg": 57009,
	"./traning.png": 62856,
	"./tumakurupooja.jpg": 83511,
	"./women's-day-celebrationn.jpg": 18829,
	"./women-mysore.jpg": 76893,
	"./women-sday.jpg": 93689,
	"./womens-day-celebration-2018.jpg": 23498,
	"./yoga-day-june21-.jpg": 65244
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 85269;